// Copyright (c) Docugami, Inc. All rights reserved.**/

import { IChoiceGroupOption } from "@fluentui/react";
import { dgFontFamily } from "components/common/Fonts";
import { primaryTheme } from "components/shell/presentation/AppStyles";
import styled from "styled-components";

const ChoiceForm = styled.form`
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 20px;
    margin: 5px 0;
`;

const Option = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 5px;
    accent-color: ${primaryTheme.palette.themeDark};
`;

const RadioButton = styled.input`
    margin: 0;
`;

const RadioButtonLabel = styled.label`
    font-family: ${dgFontFamily};
    font-size: 12px;
    line-height: 14px;
`;

interface DgChoiceGroupProps {
    options: IChoiceGroupOption[];
    selectedKey: string;
    onChange: (option: IChoiceGroupOption) => void;
    hidden?: boolean;
}

export const DgChoiceGroup = (props: DgChoiceGroupProps): JSX.Element | null => {
    if (!!props.hidden) {
        return null;
    }

    return (
        <ChoiceForm>
            {
                props.options.map(option => (
                    <Option key={option.key} onClick={(ev) => props.onChange(option)}>
                        <RadioButton key={`${option.key}_radio`} checked={option.key === props.selectedKey} type="radio" id={option.key} name={option.text} />
                        <RadioButtonLabel key={`${option.key}_label`} htmlFor={option.key}>{option.text}</RadioButtonLabel>
                    </Option>
                ))
            }
        </ChoiceForm>
    )
}